import { render } from "./companyview.vue?vue&type=template&id=906064ee"
import script from "./companyview.vue?vue&type=script&lang=js"
export * from "./companyview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__